export const styles = {
  icon: {
    width: '16px',
    height: '16px',
  },
};
